// extracted by mini-css-extract-plugin
export var active = "menu-overlay-nav-items-module--active--XCwWO";
export var item = "menu-overlay-nav-items-module--item--tOObr";
export var text = "menu-overlay-nav-items-module--text---Sj2g";